import { Box, TableCell } from "@mui/material";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useInlineSelectCellStyles } from "@common/components/inlineSelectCell/InlineSelectCell.styles";
import { UserSelectableItem } from "../../../user/User.types";

export interface IActivityResponsibleCellProps {
    selectedResponsibleId: string | null;
    options: Array<UserSelectableItem> | undefined;
    disabled: boolean;
    onChange: (responsibleId: string) => void;
}

function ActivityResponsibleCell(props: IActivityResponsibleCellProps) {
    const { translateString } = useTranslation();
    const styles = useInlineSelectCellStyles();

    return (
        <TableCell sx={{ minWidth: 200 }} onClick={(e) => e.stopPropagation()}>
            <Box sx={styles.select}>
                <DotLegalSelect
                    options={props.options}
                    onChange={(responsibleId) => responsibleId && props.onChange(responsibleId)}
                    label=""
                    noOptionsLabel=""
                    placeholder={translateString("noResponsible")}
                    variant="standard"
                    noMargin
                    selectedItem={props.selectedResponsibleId}
                    disabled={props.disabled}
                    disableClearable
                />
            </Box>
        </TableCell>
    );
}

export default ActivityResponsibleCell;
